import baseAPI from '@/api/base';
import { EditLeaveBalance, GetLeaveBalance, RegisterLeaveBalance } from '@/dtos/leave_balance.dto';
import {
  DELETE_LEAVE_BALANCE_URL,
  EDIT_LEAVE_BALANCE_URL,
  GET_LEAVE_BALANCE_URL,
  REGISTER_LEAVE_BALANCE_URL,
  TOGGLE_LEAVE_BALANCE_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class LeaveBalance {
  static getLeaveBalances = async (getLeaveBalance: GetLeaveBalance): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_LEAVE_BALANCE_URL, {
      params: getLeaveBalance,
    });
    console.log('response', response);
    return response;
  };

  static registerLeaveBalance = async (
    registerLeaveBalance: RegisterLeaveBalance
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_LEAVE_BALANCE_URL, {
      ...registerLeaveBalance,
    });
    console.log('response', response);
    return response;
  };

  static editLeaveBalance = async (editLeaveBalance: EditLeaveBalance): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_LEAVE_BALANCE_URL, {
      ...editLeaveBalance,
    });
    return response;
  };

  static toggleLeaveBalanceIsActive = async (
    editLeaveBalance: EditLeaveBalance
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_LEAVE_BALANCE_IS_ACTIVE_URL,
      {
        ...editLeaveBalance,
      }
    );
    return response;
  };

  static deleteLeaveBalance = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_LEAVE_BALANCE_URL}/${userId}`
    );
    return response;
  };
}

export default LeaveBalance;
